import { vn_app_zone_notification } from "../../vendor/valnet/valnet_jslib/vnApp/vn_app_zone_notification";
import { sentinelModule } from "../modules/sentinelModule";
import { XMLHttpRequestHandler, XMLHttpRequestHandler_requestType } from "../../vendor/valnet/valnet_jslib/XMLHttpRequestHandler/XMLHttpRequestHandler";
import { suspiciousRules_template } from "../components/templates/suspiciousRules_template";

declare var ko: any;

export class suspiciousRules extends sentinelModule {

    protected XHRHdl: XMLHttpRequestHandler;
    protected suspiciousRules_template: suspiciousRules_template;
    protected rulesRequestSeq: number = 0;

    protected getModuleName(): string {

        return "suspiciousRules";
    }

    public buildContent(): Array<Element> {

        const parentContent = super.buildContent();
        this.suspiciousRules_template = new suspiciousRules_template('suspiciousRules', this.viewModel, this);

        return [...parentContent, this.suspiciousRules_template.build()];
    }

    fillPage(): void {

        this.getPermissions();
        this.getReferences();
    }

    public onBrandChange(): void {

        this.getRules();
    }

    public onSubmitCreate(): void {

        this.postRule('/api/settings/suspicious_rules/create/');
    }

    public onSubmitEdit(): void {

        this.postRule('/api/settings/suspicious_rules/update/');
    }

    public onToggleRule(rule): void {

        this.postRule('/api/settings/suspicious_rules/toggle/', { id: rule.id });
    }

    public onDeleteRule(rule): void {

        if (!confirm('Delete this brand-specific rule?')) {
            return;
        }

        this.postRule('/api/settings/suspicious_rules/delete/', { id: rule.id });
    }

    protected getPermissions(): void {

        this.loadingIn(this.suspiciousRules_template.builtTemplate.querySelector("#suspiciousRules-results"));

        this.XHRHdl = new XMLHttpRequestHandler('/api/settings/menuData', [], this);
        this.XHRHdl.onReadyStateFunction = this.onGetPermissionsReturn;
        this.XHRHdl.execute();
    }

    protected getReferences(): void {

        this.loadingIn(this.suspiciousRules_template.builtTemplate.querySelector("#suspiciousRules-results"));

        this.XHRHdl = new XMLHttpRequestHandler('/api/settings/suspicious_rules/references/', [], this);
        this.XHRHdl.onReadyStateFunction = this.onGetReferencesReturn;
        this.XHRHdl.execute();
    }

    protected getRules(): void {

        const idBrand = this.suspiciousRules_template.getSelectedBrandId();
        if (!idBrand) {
            this.suspiciousRules_template.setRules([]);
            return;
        }

        const requestSeq = ++this.rulesRequestSeq;
        this.loadingIn(this.suspiciousRules_template.builtTemplate.querySelector("#suspiciousRules-results"));

        const params: Array<Array<string>> = [];
        params.push(["data", ko.toJSON({ idBrand: idBrand })]);
        this.XHRHdl = new XMLHttpRequestHandler('/api/settings/suspicious_rules/list/', params, this);
        this.XHRHdl.onReadyStateFunction = this.onGetRulesReturn(requestSeq);
        this.XHRHdl.execute();
    }

    protected postRule(url: string, extraPayload: object = {}): void {

        this.loadingIn(this.suspiciousRules_template.builtTemplate.querySelector("#suspiciousRules-results"));

        const payload = Object.assign({}, this.suspiciousRules_template.getViewModelForRequest(), extraPayload);
        const params: Array<Array<string>> = [];
        params.push(["data", ko.toJSON(payload)]);
        this.XHRHdl = new XMLHttpRequestHandler(url, params, this);
        this.XHRHdl.mode = XMLHttpRequestHandler_requestType.POST;
        this.XHRHdl.onReadyStateFunction = this.onSaveReturn(payload);
        this.XHRHdl.execute();
    }

    protected onGetPermissionsReturn(req, obj) {

        return function () {

            obj.manageResponse(req, obj, function () {

                let responseParsed = JSON.parse(req.request.response);
                obj.suspiciousRules_template.setSideMenuPermissionsData(responseParsed);
            });
        }
    }

    protected onGetReferencesReturn(req, obj) {

        return function () {

            obj.manageResponse(req, obj, function () {

                let responseParsed = JSON.parse(req.request.response);
                if (responseParsed.type === 'error') {
                    obj.getVnAppZone().notification = new vn_app_zone_notification(vn_app_zone_notification.TYPE_ERROR, responseParsed.message);
                    obj.getVnAppZone().showNotificationToModule();
                    return;
                }

                obj.suspiciousRules_template.setReferences(responseParsed);
            });

            obj.loadingOut(obj.suspiciousRules_template.builtTemplate.querySelector("#suspiciousRules-results"));
        }
    }

    protected onGetRulesReturn(requestSeq: number) {

        return (req, obj) => {

            return function () {

                if (requestSeq !== obj.rulesRequestSeq) {
                    return;
                }

                obj.manageResponse(req, obj, function () {

                    let responseParsed = JSON.parse(req.request.response);
                    const selectedBrandId = obj.suspiciousRules_template.getSelectedBrandId();
                    if (responseParsed.idBrand && selectedBrandId && Number(responseParsed.idBrand) !== Number(selectedBrandId)) {
                        return;
                    }
                    obj.suspiciousRules_template.setRules(responseParsed.rules || []);
                });

                obj.loadingOut(obj.suspiciousRules_template.builtTemplate.querySelector("#suspiciousRules-results"));
            }
        };
    }

    protected onSaveReturn(payload) {

        return (req, obj) => {

            return function () {

                obj.manageResponse(req, obj, function () {

                    obj.suspiciousRules_template.clearErrors();
                    let responseParsed = JSON.parse(req.request.response);

                    if (responseParsed.permalinkError) {
                        obj.suspiciousRules_template.getTemplateViewModel().permalinkError(responseParsed.permalinkError);
                    } else if (responseParsed.generalError) {
                        obj.suspiciousRules_template.getTemplateViewModel().generalError(responseParsed.generalError);
                    } else if (responseParsed.type === 'error') {
                        obj.suspiciousRules_template.getTemplateViewModel().generalError(responseParsed.message);
                    } else {
                        obj.suspiciousRules_template.setSelectedBrandId(responseParsed.idBrand || payload.idBrand);
                        obj.suspiciousRules_template.onCloseCreate();
                        obj.suspiciousRules_template.onCloseEdit();
                        obj.suspiciousRules_template.setRules(responseParsed.rules || []);
                        obj.getRules();
                        obj.getVnAppZone().notification = new vn_app_zone_notification(vn_app_zone_notification.TYPE_SUCCESS, "Suspicious rule saved.");
                        obj.getVnAppZone().showNotificationToModule();
                    }
                });

                obj.loadingOut(obj.suspiciousRules_template.builtTemplate.querySelector("#suspiciousRules-results"));
            }
        };
    }
}



// WEBPACK FOOTER //
// ./js/modules/suspiciousRules.ts